App.OrderCourierMiniPopupComponent = Em.Component.extend
  env:      Em.inject.service('environment')

  classNames: [ 'order-courier-mini-popup' ]

  selectedCourier: Em.computed.oneWay('order.courier')
  isLoading: false
  searchText: ''

  isSaveDisabled: (->
    @get('order.courier.id') is @get('selectedCourier.id')
  ).property('order.courier.id', 'selectedCourier.id')

  buttonLabel: (->
    return Em.I18n.t 'courier.edit.buttons.assign' if @get('selectedCourier')
    Em.I18n.t 'courier.edit.buttons.cancel_assigment'
  ).property('selectedCourier','currentCourier')

  outsourceCancelButtonText: (->
    return '' unless @get('order.external_delivery.provider')
    "#{Em.I18n.t 'courier.edit.buttons.cancel_order_in'} #{Em.I18n.t 'delivery.zone.providers.' + @get('order.external_delivery.provider').toLowerCase()}"
  ).property('order.external_delivery','order.external_delivery.provider')

  outsourcePlaceButtonText: (->
    return '' unless @get('order.external_delivery.provider')
    "#{Em.I18n.t 'courier.edit.buttons.create_an_app_in'} #{Em.I18n.t 'delivery.zone.providers.' + @get('order.external_delivery.provider').toLowerCase()}"
  ).property('order.external_delivery','order.external_delivery.provider')

  initialize: (->
    if @get('active')
      @set('selectedCourier', @get('order.courier'))
      @set('currentCourier', @get('order.courier'))
  ).observes('active','order')

  filteredCouriers:( ->
    searchText = @get('searchText');
    couriers = @get('couriers');
    if (searchText)
      return couriers.filter((courier) => courier.get('name').toLowerCase().includes(searchText.toLowerCase()));
    return couriers
  ).property('searchText', 'couriers')

  actions:
    cancelOutsource: ->

      unless @get('cancelOutsourceConfirm')
        @set('cancelOutsourceConfirm', true)
        return

      @set('isLoading', true)

      # TODO - стоило бы перенести этот метод в модель заказа
      @get('order').nonRESTAction('PUT', 'cancel_outsource', {})
      .then =>
        @get('order').reload()
      .finally =>
        @set('cancelOutsourceConfirm', false)
        @set('isLoading', false)

    allOutsourceCancel: ->
        @set('placeOutsourceConfirm', false)
        @set('cancelOutsourceConfirm', false)
        return
    placeOutsource: ->

      unless @get('placeOutsourceConfirm')
        @set('placeOutsourceConfirm', true)
        return

      @set('isLoading', true)

      # TODO - стоило бы перенести этот метод в модель заказа
      @get('order').nonRESTAction('PUT', 'place_outsource', {})
      .then =>
        @get('order').reload()
      .finally =>
        @set('placeOutsourceConfirm', false)
        @set('isLoading', false)

    saveCourier: ->
      @set('isLoading', true)
      @set('order.courier', @get('selectedCourier'))
      order = @get('order')
      order.nonRESTAction('PUT', '', {courier_id: @get('selectedCourier.id')})
      .then =>
        @get('popups').send('closePopup')
      .catch =>
        false
      .finally =>
        @set('isLoading', false)
      false

    selectCourier: (courier) ->
      if courier && @get('selectedCourier.id') == courier.get('id')
        @set('selectedCourier', null)
        return false
      @set('selectedCourier', courier)
      courier.getStatus(@get('order.id'))
      false
